module.exports = "https://coursera_assets.s3.amazonaws.com/images/54e0e0ac5da4f6184bda8d9a69ebf237.png";